import { Breadcrumb, Toast, User, SwatchAppState, UiAppState } from "@/types";

export const appMutations = {
  setLoggedInUser(state: SwatchAppState, userInfo: User) {
    state.loggedInUser = userInfo;
  },
  setEcList(state: SwatchAppState, payload: any) {
    state.ecList = payload;
  },
  setSelectedEc(state: SwatchAppState, payload: any) {
    state.selectedEc = payload;
  },
  storeCmsSearchProducts(state: SwatchAppState, searchResult: any) {
    state.productSearchResultsTable = searchResult;
  },
  setSelectedSearchProduct(state: SwatchAppState, product: any) {
    state.searchedProductSelected = product;
  },
  resetBreadcrumb(state: SwatchAppState) {
    state.breadcrumb = {
      items: [],
      routeActive: ""
    };
  },
  setBreadcrumb(state: SwatchAppState, payload: Breadcrumb) {
    state.breadcrumb = payload;
  },
  storeInventorySearchProducts(state: SwatchAppState, payload: any) {
    state.inventoryProductSearchResult = Object.assign({}, payload);
  },
  storeInventorySearchSKUs(state: SwatchAppState, payload: any) {
    state.inventorySkuDetails = Object.assign({}, payload);
  },
  storeInventorySearchSamples(state: SwatchAppState, payload: any) {
    state.inventorySampleDetails = Object.assign({}, payload);
  },
  storeLendingHistory(state: SwatchAppState, payload: any) {
    state.lendingHistoryDetails = Object.assign({}, payload);
  },
  setSelectedInventoryFinish(state: SwatchAppState, payload: any) {
    state.searchedProductSelected = Object.assign({}, payload);
  },
  analyticsInstance(state: SwatchAppState, payload: any) {
    state.analyticsInstance = payload;
  },
  auth(state: SwatchAppState, payload: any) {
    state.auth = payload;
  },
  config(state: SwatchAppState, payload: any) {
    state.config = payload;
  }
};

export const uiMutations = {
  setModalProperties(state: UiAppState, payload: { [key: string]: string }) {
    state.modalElement = Object.assign(state.modalElement, payload);
  },
  showLoadingModal(state: UiAppState) {
    state.modalElement.isVisible = true;
  },
  hideLoadingModal(state: UiAppState) {
    state.modalElement.isVisible = false;
  },
  addToastItem(state: UiAppState, payload: Toast) {
    state.toastsList.unshift(payload);
  },
  clearToast(state: UiAppState, payload: Toast) {
    const toastIdx = state.toastsList.findIndex((toast: Toast) => {
      return toast.key === payload.key;
    });
    if (toastIdx > -1) {
      state.toastsList.splice(toastIdx, 1);
    }
  }
};
